export const URL_HOME = '/',
    URL_KIDS_CARD_OFFER = '/kids_card_offer',
    URL_BOLT = '/cards/bolt',
    URL_CASHBACK = '/cards/cashback_ua',
    URL_ATB = '/cards/atb',
    URL_HAPPY_ATB = '/special_offers/ATB_offer',
    URL_SUNNY_TARIFF = '/special_offers/sunny_tariff',
    URL_VYGODA = '/cards/vygoda',
    URL_INSTALLMENT = '/credit/installment_from_statement',
    URL_ENERGY = '/business/energy_all',
    URL_PBP = '/credit/pbp',
    URL_SEARCH = '/search',
    URL_BRANCHES = '/branches',
    URL_SERVICES = '/services/abank',
    URL_CONTACTS = '/contacts',
    URL_INVITE_FRIEND = '/services/invite_friend',
    URL_INSURANCE = '/services/insurance',
    URL_SAFE_BOXES = '/services/safe_boxes',
    URL_ACQUIRING = '/business/acquiring',
    URL_BECOME_PARTNER = '/services/become-partner',
    URL_TRANSFERS = '/services/transfers',
    URL_QUICK_CASH = '/credit/quick_cash',
    URL_NEWS = '/news',
    URL_DIIA = '/cards/diia',
    DIIA_ESPORT_PARAM = '?esport',
    DIIA_EBOOK_PARAM = '?ebook',
    URL_VETERAN = `${URL_DIIA}${DIIA_ESPORT_PARAM}`,
    URL_BOOK = `${URL_DIIA}${DIIA_EBOOK_PARAM}`;
